import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NewClientForm = ({ isOpen, onClose, selectedRowData }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [companyname, setCompanyname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [lpo, setLpo] = useState('');


  const postData = async () => {
    if (!firstName || !lastName || !companyname || !phone) {
      toast.warn(`Fill Fields!`);
    }
    else {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/clients/add_client`, {
        "firstname": firstName,
        "lastname": lastName,
        "companyname": companyname,
        "email": email,
        "phone": phone,
        "address": address,
        "lponumber": lpo
      })
      if (response.status === 200) {
        toast.success(`Client created successfully!"`);
      }
    }
  }
  const updateData = async () => {
    if (!firstName || !lastName || !companyname || !phone) {
      toast.warn(`Fill Fields!`);
    }
    else {
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/clients/edit_client`, {
        "id": selectedRowData.id,
        "firstname": firstName,
        "lastname": lastName,
        "companyname": companyname,
        "email": email,
        "phone": phone,
        "address": address,
        "lponumber": lpo
      })
      if (response.status === 200) {
        toast.success(`Client updated successfully!"`);
      }
    }
  }


  useEffect(() => {
    // Populate form fields with selectedRowData when it changes
    if (selectedRowData) {
      // Assuming you have form fields like firstName, lastName, etc.
      setFirstName(selectedRowData.firstname);
      setLastName(selectedRowData.lastname);
      setCompanyname(selectedRowData.companyname);
      setEmail(selectedRowData.email);
      setPhone(selectedRowData.phone);
      setAddress(selectedRowData.address);
      setLpo(selectedRowData.lponumber)
    }
    else {
      setFirstName('');
      setLastName('');
      setCompanyname('');
      setEmail('');
      setPhone('');
      setAddress('');
      setLpo('')
    }
  }, [selectedRowData]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (selectedRowData) {
      updateData()
    }
    else {
      postData()
    }

    setFirstName('');
    setLastName('');
    setCompanyname('');
    setEmail('');
    setPhone('');
    setAddress('');
    setLpo('')

    onClose();
  };

  return (
    <div className=' max-h-[80vh] overflow-auto' style={{
      display: isOpen ? 'block' : 'none',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      padding: '20px',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
      zIndex: '999',
      backdropFilter: 'blur(5px)',
      overflowY: 'auto',
      height: '650px'
    }}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <h2 className='text-2xl font-bold font-poppins ml-2 mt-3 mb-3'>{selectedRowData ? "Update Client" : "Add New Client"}</h2>
      <form onSubmit={handleSubmit}>
        <TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="First Name"
          onChange={(e) => setFirstName(e.target.value)}
          value={firstName}
          fullWidth
          required
          sx={{ mb: 4 }}
        />
        <TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="Last Name"
          onChange={(e) => setLastName(e.target.value)}
          value={lastName}
          fullWidth
          required
          sx={{ mb: 4 }}
        />
        <TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="Company Name"
          onChange={(e) => setCompanyname(e.target.value)}
          value={companyname}
          fullWidth
          sx={{ mb: 4 }}
        />
        <TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="Phone Number"
          onChange={(e) => setPhone(e.target.value)}
          value={phone}
          fullWidth
          required
          sx={{ mb: 4 }}
        />
        <TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="Address"
          onChange={(e) => setAddress(e.target.value)}
          value={address}
          fullWidth
          sx={{ mb: 4 }}
        />
        <TextField
          type="email"
          variant="outlined"
          color="secondary"
          label="Email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          fullWidth
          // required
          sx={{ mb: 4 }}
        />
        <TextField
          type="text"
          variant="outlined"
          color="secondary"
          label="LPO Number (Optional)"
          onChange={(e) => setLpo(e.target.value)}
          value={lpo}
          fullWidth
          // required
          sx={{ mb: 4 }}
        />

        <button
          type='submit'
          className='w-[120px] rounded font-bold font-poppins text-white bg-[#007FFF] p-2 mr-5 mt-2 mb-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
        >
          {selectedRowData ? "Update Client" : "Add Client"}
        </button>
      </form>
      <button
        onClick={onClose}
        className='w-[120px] text-red-500 border border-red-500 rounded font-bold font-poppins bg-white p-2 mr-5 mt-2 mb-2 hover:bg-red-500 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'
      >
        Close
      </button>

    </div>
  );
};

export default NewClientForm;
